import { capitalize } from 'lodash'
import { AccordionList, AccordionListContainer, AccordionListContent, AccordionListItem, AccordionListTrigger, List } from 'twyne-new.ui'

import { usePalette } from '@/modules/cms/views/post/components/builder/context'

import DraggableAssetItem from './DraggableAssetItem'
import VariantAssetItem from './VariantAssetItem'

export default function Assets({ floatbarRef }) {
  const palette = usePalette()

  return <>
    <AccordionListContainer>
      <AccordionList type='multiple' defaultValue={['Content', 'Layout', 'Structures', 'Form', 'Dynamic', 'Embedded', 'Containers']}>
        {palette.map(({ items, name }, idx) => <AccordionListItem value={name} key={idx}>
          <AccordionListTrigger>{capitalize(name)}</AccordionListTrigger>
          <AccordionListContent>
            <List>
              {items.map((item, idx) => {
                const { variants } = item

                if (variants) {
                  return <VariantAssetItem key={idx}
                    item={item}
                    floatbarRef={floatbarRef}
                  />
                }

                return <DraggableAssetItem key={idx}
                  item={item}
                />
              })}
            </List>
          </AccordionListContent>
        </AccordionListItem>)}
      </AccordionList>
    </AccordionListContainer >
  </>
}
